import React, { useRef, useState } from "react";
import { Tooltip } from "../../Shared/Table";

const LinkedCampaignsCell: React.FC<{
    label: string;
    tooltipText: string;
}> = ({ label, tooltipText }) => {
    const ref = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const toggleHover = () => setShowTooltip(!showTooltip);
    return (
        <>
            <div ref={ref} className="header-container" onMouseEnter={toggleHover} onMouseLeave={toggleHover}>
                <div className="">{label}</div>
            </div>
            <Tooltip reference={ref} shouldShow={showTooltip}>
                <div className="uppercase font-thin text-xs text-gray-600">Linked Campaigns</div>
                <div>{tooltipText}</div>
            </Tooltip>
        </>
    );
};

export default LinkedCampaignsCell;
